import {
  Box,
  Grid,
  GridItem,
  SystemProps,
  Text,
  TextProps,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { Children } from "react";

import { IcoCheckCircle, IcoCircle } from "@/common/components/Icons";
import { IconSizesType } from "@/theme/Icon.theme";

type CheckIconProps = {
  value: boolean;
  size?: IconSizesType;
};
export function CheckIcon({ value, size = "md" }: CheckIconProps) {
  const iconSuccessColor = useColorModeValue("green.500", "green.500");
  const iconIntermediateColor = useColorModeValue("gray.400", "gray.500");
  return (
    <>
      {value ? (
        <Box color={iconSuccessColor}>
          <IcoCheckCircle size={size} />
        </Box>
      ) : (
        <Box color={iconIntermediateColor}>
          <IcoCircle size={size} />
        </Box>
      )}
    </>
  );
}

export function CheckListItem({
  title,
  isChecked,
  children,
  contentHidden = false,
  rowGap = 1.5,
  _title,
  _checkIcon,
}: {
  title: string;
  isChecked: boolean;
  children?: React.ReactNode;
  isLast?: boolean;
  contentHidden?: boolean;
  rowGap?: SystemProps["rowGap"];
  _title?: TextProps;
  _checkIcon?: Omit<CheckIconProps, "value">;
}) {
  return (
    <Grid columnGap={1.5} rowGap={rowGap} templateColumns={"auto 1fr"}>
      <GridItem alignSelf={"center"} justifySelf="center">
        <CheckIcon value={isChecked} {..._checkIcon} />
      </GridItem>
      <GridItem alignSelf={"center"}>
        <Text fontSize="sm" fontWeight="medium" {..._title}>
          {title}
        </Text>
      </GridItem>
      {Children.toArray(children).length > 0 && (
        <>
          <GridItem justifySelf="center" />
          <GridItem>{!contentHidden && children}</GridItem>
        </>
      )}
    </Grid>
  );
}
